function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// /Users/akshetpandey/workspace/thriller-server/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 1
// module chunks = 168707334958949